import axios from 'axios';

export const getAllQuotes = async (params) => {
    const url = `/api/v1/user_profile/quotes`;
    const res = await axios.get(url, { params });
    return res.data;
};

export const createQuote = async (data) => {
    const url = `/api/v1/user_profile/quotes`;
    const res = await axios.post(url, data);
    return res.data;
}

export const updateQuote = async (quoteId, data) => {
    const url = `/api/v1/user_profile/quotes/${quoteId}`;
    const res = await axios.patch(url, data);
    return res.data;
}

export const deleteQuote = async (quoteId) => {
    const url = `/api/v1/user_profile/quotes/${quoteId}`;
    await axios.delete(url);
}

export const getQuote = async (quoteId) => {
    const url = `/api/v1/user_profile/quotes/${quoteId}`;
    const res = await axios.get(url);
    return res.data;
}

export const getEmailMessage = async (quoteId) => {
    const url = `/api/v1/user_profile/quotes/${quoteId}/email_message`;
    const res = await axios.get(url);
    return res.data;
}